var path = 'src/app/ui/metadata.html';
var html = "<table class=metadata> <tr> <th>ID</th> <td>{{item.id}}</td> </tr> <tr> <th>Created User</th> <td>{{item.createdUser.username | missing}}</td> </tr> <tr> <th>Created Date</th> <td>{{item.createdDate | dateTimeFormat}}</td> </tr> <tr> <th>Modified User</th> <td>{{item.modifiedUser.username | missing}}</td> </tr> <tr> <th>Modified Date</th> <td>{{item.modifiedDate | dateTimeFormat}}</td> </tr> </table> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/ui/metadata.html
 ** module id = 677
 ** module chunks = 0
 **/